import { useMutation } from '@apollo/client';
import type { LearnerProfile_PhoneInput } from '__generated__/graphql-types';

import LearnerProfilePatchPersonalInformationMutation from 'bundles/expression-of-interest/queries/LearnerProfilePatchPersonalInformation.graphql';
import type {
  LearnerProfile_PatchPersonalInformationPhoneMutation as LearnerProfilePatchPersonalInformationMutationType,
  LearnerProfile_PatchPersonalInformationPhoneMutationVariables as LearnerProfilePatchPersonalInformationMutationVariables,
} from 'bundles/expression-of-interest/queries/__generated__/LearnerProfilePatchPersonalInformation';

const useLearnerProfilePatchPersonalInformation = () => {
  const [patchPersonalInformationMutation] = useMutation<
    LearnerProfilePatchPersonalInformationMutationType,
    LearnerProfilePatchPersonalInformationMutationVariables
  >(LearnerProfilePatchPersonalInformationMutation, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const patchPhone = async (phone: LearnerProfile_PhoneInput) => {
    const { data, errors } = await patchPersonalInformationMutation({
      variables: {
        input: {
          phone: { phone },
        },
      },
    });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (data?.LearnerProfile_PatchPersonalInformation?.__typename === 'LearnerProfile_PatchFailure') {
      return {
        success: false,
        errors: data.LearnerProfile_PatchPersonalInformation.errors.map((error) => error.message),
      };
    }

    return { success: true, errors: [] };
  };

  return { patchPhone };
};

export default useLearnerProfilePatchPersonalInformation;
